<template>
  <div class="prod">
    <div
      class="full-section full-section__main anim anim-opacity-1"
      data-section="start"
      data-anim
    >
      <div v-rellax="rellax" class="rellax">
        <img src="@/assets/img/catalogue/monolith/1.jpg" alt="" />
      </div>
    </div>

    <div class="grid">
      <div class="section text-wrap" data-section="title" data-anim>
        <span class="text anim anim-scene-1">Monolith</span>
        <span class="text-line"></span>
      </div>

      <div class="section" data-section="center">
        <div class="col-left" data-anim>
          <img
            src="@/assets/img/catalogue/monolith/2.jpg"
            alt=""
            class="anim anim-scene-1"
          />
        </div>
      </div>

      <div class="section" data-section="2">
        <div class="col-left" data-anim>
          <img
            src="@/assets/img/catalogue/monolith/3.jpg"
            alt=""
            class="anim anim-scene-1"
          />
        </div>
        <div class="col-right" data-anim>
          <img
            src="@/assets/img/catalogue/monolith/4.jpg"
            alt=""
            class="anim anim-scene-2 anim-scene-1-mob"
          />
        </div>
      </div>

      <div class="section" data-section="center" data-anim>
        <div class="col-left" data-anim>
          <img
            src="@/assets/img/catalogue/monolith/5.jpg"
            alt=""
            class="anim anim-scene-1"
          />
        </div>
      </div>
    </div>

    <Form />

    <NextSection
      subtitle="следующий концепт"
      title="Panorama"
      link="/catalog/panorama"
      image="catalogue/monolith/next.jpg"
      imageMob="catalogue/monolith/next_mob.jpg"
    />
  </div>
</template>

<script>
import anims from "@/mixins/anims";
import rellax from "../../../mixins/rellax";
import Form from "@/components/common/Form";
import NextSection from "../../common/NextSection.vue";

export default {
  name: "Monolith",

  components: {
    Form,
    NextSection,
  },

  mixins: [anims, rellax],
};
</script>
<style lang="scss" scoped>
@import "@/styles/product_card.scss";
</style>
